type StatusChangeCallback = (online: boolean) => void;

export function isBrowserOffline(): boolean {
	return typeof navigator !== 'undefined' && !navigator.onLine;
}

function createNetworkStatus() {
	let online = $state(!isBrowserOffline());
	let cleanup: (() => void) | null = null;

	return {
		get isOnline(): boolean {
			return online;
		},

		init(onChange?: StatusChangeCallback): () => void {
			const handleOnline = () => {
				online = true;
				onChange?.(true);
			};
			const handleOffline = () => {
				online = false;
				onChange?.(false);
			};

			window.addEventListener('online', handleOnline);
			window.addEventListener('offline', handleOffline);

			cleanup = () => {
				window.removeEventListener('online', handleOnline);
				window.removeEventListener('offline', handleOffline);
			};

			return cleanup;
		},

		destroy(): void {
			cleanup?.();
			cleanup = null;
		}
	};
}

export const networkStatus = createNetworkStatus();
